export class PageResponseDto<T> {
  constructor(
    public items: T[] = [],
    public totalCount: number = 0,
    public rus: number = 0,
    public continuationToken: string | null = null
  ) { }
}